import * as React from 'react';
import * as ReactDOM from 'react-dom';
import LiteratureWizard from './LiteratureWizard';

import registerServiceWorker from './registerServiceWorker';

/**
 * Debugger
 *
 * Responsibility:
 * Debugger for literature wizard application
 */
class Debugger extends React.Component {
    /**
     * Debugger::render()
     *
     * Responsibility:
     * Render view
     *
     * @returns {any}
     */
    public render() {
        return (
            <LiteratureWizard/>
        );
    }
}

/**
 * Render top level DOM
 */
ReactDOM.render(
    <Debugger/>,
    document.getElementById('root') as HTMLElement
);

/**
 * Register service worker
 */
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx